// @ts-nocheck

import React from "react";

import styles from "./SearchSuggestion.module.scss";
import { SearchSuggestionProps, Suggestion } from "./SearchSuggestions.props";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

function SearchSuggestions<SuggestionsData>({
  id,
  testId,
  suggestions,
  handleSuggestionClick,
  text,
  autoCompleteClassName,
  suggestionBoxHint,
  suggestionTitle,
  loading,
}: SearchSuggestionProps<SuggestionsData>): React.ReactElement {
  // code to bold out letters that match the typed text
  const boldMatchedText = (suggestion: Suggestion<SuggestionsData>): Array<string | React.ReactElement> => {
    const textLength = text.length;
    const content = [];
    for (let i = 0; i < suggestion.suggestionLabel.length; i++) {
      if (suggestion.suggestionLabel.slice(i, i + textLength).toLowerCase() === text.toLowerCase()) {
        content.push(<strong key={`text-${i}`}>{suggestion.suggestionLabel.slice(i, i + textLength)}</strong>);
        i += textLength - 1;
      } else {
        content.push(suggestion.suggestionLabel[i]);
      }
    }
    return content;
  };

  let suggestionsComponent;

  if (loading) {
    let i = 0;
    const suggestionsLength = 4;
    suggestionsComponent = [];
    while (i < suggestionsLength) {
      suggestionsComponent.push(
        <p key={i} data-testid={`test-search-loading-${i}__${id}`} className={styles["suggestions-options"]}>
          {<Skeleton width={"56px"} height={16} />} {<Skeleton width={"85px"} height={16} />}
        </p>,
      );
      i++;
    }
  } else if (suggestions && suggestions.length) {
    suggestionsComponent = suggestions.map((suggestion: Suggestion<SuggestionsData>, idx: number) => {
      const content = boldMatchedText(suggestion);
      return (
        <p
          key={idx}
          data-testid={testId ? `test__search-suggestion-options-${idx}__${testId}` : undefined}
          className={styles["suggestions-options"]}
          onClick={(): void => handleSuggestionClick(suggestion.suggestionLabel, suggestion.data)}
          tabIndex={-1}
        >
          {content}
        </p>
      );
    });
  } else {
    suggestionsComponent = <p className={styles["suggestions-none"]}>{suggestionBoxHint}</p>;
  }

  const autoCompleteClasses = cn(styles["autocomplete"], autoCompleteClassName);
  return (
    <div className={autoCompleteClasses} data-testid={testId ? `test__search-suggestion-container__${testId}` : undefined}>
      <h5 id={`H4-${id}`} className={styles["suggestion-body-header"]}>
        {suggestionTitle !== null && suggestionTitle}{" "}
      </h5>

      <div className={`${styles["suggestions-list"]} displayedSuggestions`}>{suggestionsComponent}</div>
    </div>
  );
}

export default SearchSuggestions;
